import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";

import * as Yup from "yup";
import PatientOtherMedicalInfo from "../../../components/Patient_SelfOnboard/PatientOtherMedicalInfo";
import SelfMedicalInfo from "../../../components/Patient_SelfOnboard/SelfMedicalInfo";
import SelfBloodThinnerMedications from "../../../components/Patient_SelfOnboard/SelfBloodThinnerMedications";
import Self_General_Medications from "../../../components/Patient_SelfOnboard/Self_General_Medications";
import SelfPastMedications from "../../../components/Patient_SelfOnboard/SelfPastMedications";
import SelfCurrentPainMedications from "../../../components/Patient_SelfOnboard/SelfCurrentPainMedications";

const validationSchema = Yup.object().shape({
 /*   Recommendation_letter_use_cannabis:Yup.string().nullable().required('This field is mandatory'),
    Psychiatric_diagnosis:Yup.string().nullable().required('This field is mandatory'),
    Current_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Past_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Nuclear_family_psychosis:Yup.string().nullable().required('This field is mandatory'),
    Drug_abuse:Yup.string().nullable().required('This field is mandatory'),
    Cardiovascular_history:Yup.string().nullable().required('This field is mandatory'),
    Cardiovascular_risk:Yup.string().nullable().required('This field is mandatory'),
    Lung_disease:Yup.string().nullable().required('This field is mandatory'),*/
})

class SelfMedicalInfoTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


     componentWillMount() {
        this.props.initValidation(validationSchema)
    }

    onValueChange = (name,value) => {
        this.props.onValueChange(name,value)
    }
    onYesNoValueChange = (name,value) => {
        this.props.onYesNoValueChange(name,value)
    }
    onclickSetIsOtherMedicalDiagnosis = () => {
        this.props.onclickSetIsOtherMedicalDiagnosis()
    }
    onClickMedicationConditions = (value) => {
        this.props.onClickMedicationConditions(value)
    }
    onClickPatientAllergics = (value) => {
        this.props.onClickPatientAllergics(value)
    }
    onClickAddDeleteMedications = (index,event,id,type) => {
        this.props.onClickAddDeleteMedications(index,event,id,type)
    }
    addDeleteMedication = (func,index) => {
        this.props.addDeleteMedication(func,index)
    }
    render() {
        let {t} = this.props

        return (
            <div  className={'patientForm-box-container'}>

                <FormElementContainer title={t('patient_self_boarding.Medical_information')}
                                      Component={SelfMedicalInfo}
                                      rest={{
                                          onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                          onValueChange:(name,value) => this.onValueChange(name,value),
                                          entry:this.props.entry,
                                          onClickPatientAllergics:(val) =>this.onClickPatientAllergics(val),
                                          patient_allergics:this.props.patient_allergics,
                                          allergics:this.props.allergics,
                                          onClickMedicationConditions:(value) => this.onClickMedicationConditions(value),
                                          medicalConditions:this.props.medicalConditions,
                                          medicalConditionsSelected:this.props.medicalConditionsSelected,
                                          errors:this.props.errors,
                                          t:(e) => this.props.t(e)
                                      }}/>
                <FormElementContainer title={t('patient_self_boarding.current_medications')}
                                      Component={SelfCurrentPainMedications}
                                      rest={{
                                          onClickPatientAllergics:(val) =>this.onClickPatientAllergics(val),
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          currentPain_medications:this.props.currentPain_medications,
                                          patient_allergics:this.props.patient_allergics,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>

                <FormElementContainer title={t('patient_self_boarding.past_medications')}
                                      Component={SelfPastMedications}
                                      rest={{
                                          onClickPatientAllergics:(val) =>this.onClickPatientAllergics(val),
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          past_med:this.props.past_med,
                                          isOtherPastUseMedication:this.props.isOtherPastUseMedication,
                                          patient_allergics:this.props.patient_allergics,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>

                <FormElementContainer title={t('patient_self_boarding.general_medications')}
                                      Component={Self_General_Medications}
                                      rest={{
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          general_medications:this.props.general_medications,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>

                <FormElementContainer title={t('patient_self_boarding.Blood_thinners_Medications')}
                                      Component={SelfBloodThinnerMedications}
                                      rest={{
                                          addDeleteMedication:(func,index) =>this.addDeleteMedication(func,index),
                                          onValueChange:(name,value) => this.onValueChange(name,value) ,
                                          entry:this.props.entry,
                                          onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                          t:(e) => this.props.t(e),
                                          onClickAddDeleteMedications: (index,event,id,type) => this.onClickAddDeleteMedications(index,event,id,type),
                                          bloodThinner_medications:this.props.bloodThinner_medications,
                                          medicationsList:this.props.medicationsList,
                                          errors:this.props.errors
                                      }}/>
                    <FormElementContainer title={t('patient_self_boarding.Other_Medical_information')}
                                          Component={PatientOtherMedicalInfo}
                                          rest={{
                                              onYesNoValueChange:(name, value) => this.onYesNoValueChange(name, value),
                                              onValueChange:(name,value) => this.onValueChange(name,value) ,
                                              entry:this.props.entry,
                                              errors:this.props.errors,
                                              t:(e) => this.props.t(e)
                                          }}/>
            </div>
        );
    }
}



const SelfMedicalInfoTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(SelfMedicalInfoTabComposed);

export default SelfMedicalInfoTab;

